import * as React from 'react';
import styled from 'styled-components';

import { flexGap } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '../../colors-v2';

const Dot = styled.div`
  width: 4px;
  height: 4px;
  min-width: 4px;
  min-height: 4px;

  background-color: ${colorsV2.neutral100};
  border-radius: 50%;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${flexGap(24)}

  padding: 16px;
`;

export const BlogEditorElementDividerIndicator = () => {

  return (
    <Container className="blog-editor-element-divider-indicator">
      <Dot />
      <Dot />
      <Dot />
    </Container>
  );
};
